import React from 'react';
import { Box, Accordion, AccordionSummary, AccordionDetails, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import AddIcon from '@mui/icons-material/Add';
import SectionHeading from './SectionHeading';
import { useT } from '../../i18n/LanguageContext';

const getFaqs = (t) => [
  { q: t('home.faq.q1'), a: t('home.faq.a1') },
  { q: t('home.faq.q2'), a: t('home.faq.a2') },
  { q: t('home.faq.q3'), a: t('home.faq.a3') },
  { q: t('home.faq.q4'), a: t('home.faq.a4') },
  { q: t('home.faq.q5'), a: t('home.faq.a5') },
  { q: t('home.faq.q6'), a: t('home.faq.a6') },
  { q: t('home.faq.q7'), a: t('home.faq.a7') },
];

export default function Faq() {
  const theme = useTheme();
  const t = useT();
  const faqs = getFaqs(t);
  return (
    <Box id="faq" sx={{ bgcolor: theme.home.paper, py: theme.home.sectionPy }}>
      <Box sx={{ maxWidth: 860, mx: 'auto', px: { xs: 3, md: 5 } }}>
        <SectionHeading align="center" eyebrow={t('home.faq.eyebrow')} title={t('home.faq.title')} />
        <Box sx={{ mt: { xs: 4, md: 6 } }}>
          {faqs.map((f, i) => (
            <Accordion
              key={i}
              disableGutters elevation={0}
              sx={{
                bgcolor: 'transparent', borderBottom: `1px solid ${theme.home.paperDeep}`,
                '&:before': { display: 'none' },
              }}
            >
              <AccordionSummary expandIcon={<AddIcon sx={{ color: theme.home.cyanText }} />} sx={{ px: 0, py: 1 }}>
                <Typography sx={{ fontFamily: theme.home.display, fontWeight: 600, fontSize: { xs: '1.15rem', md: '1.35rem' }, color: theme.home.ink }}>
                  {f.q}
                </Typography>
              </AccordionSummary>
              <AccordionDetails sx={{ px: 0, pb: 3 }}>
                <Typography sx={{ color: theme.home.inkMuted, lineHeight: 1.7, fontSize: '1.05rem' }}>{f.a}</Typography>
              </AccordionDetails>
            </Accordion>
          ))}
        </Box>
      </Box>
    </Box>
  );
}
